<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Data', 'Associado', 'Detalhes']"
            :showReload="true"
            :showTipFooter="false"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn IsDatetime :status="1" :value="obj.data" />
        <TableColumn IsText :status="1" :value="obj.cooperado" />
        <TableColumn IsText :status="1" :value="obj.detalhes" />
      </tr>
    </Tables>
    <button
              type="button"
              class="btn btn-third btn-sm"
              v-b-tooltip.hover
              :title="$lang.Common.Tooltip.ButtonBack"
              @click="onBack"
            >
              <i class="fas fa-undo"></i>
              <span class="d-md-down-none">{{
                $lang.Common.Buttons.Back
              }}</span>
            </button>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import FollowupRepository from '@/shared/http/repositories/associate/followup.js'

export default {
  name: 'MinhasVisitasList',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      FollowupRepository.GetAllMinhasVisitasPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      FollowupRepository.Delete(obj.id)
        .then(this.onResult)
        .catch(this.onException)
    },
    onBack () {
      this.$router.push({ name: 'Visitas' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/visitas/minhasVisitas/components/list/minhasVisitasList.vue